module.exports = __webpack_public_path__ + "img/light-Path 25 Copy@3x.ce3e3189.png";